import { render, staticRenderFns } from "./UserPermissionsModal.vue?vue&type=template&id=4f9fbd00&"
import script from "./UserPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionsModal.vue?vue&type=style&index=0&id=4f9fbd00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports